import { fetchData, backend } from "@/services/backend";

export default {
  install(Vue, options) {
    Object.defineProperty(Vue.prototype, "$backend", {
      get() {
        return backend;
      },
    });
  },
};
